import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1493.33,320 L1493.33,0 L1600,0 L1600,320 L1920,320 L1920,426.667 L1600,426.667 L1600,746.667 L1493.33,746.667 L1493.33,426.667 L1173.33,426.667 L1173.33,320 L1493.33,320 Z M160,426.667 C130.545,426.667 106.667,450.545 106.667,480 L106.667,1760 C106.667,1789.46 130.545,1813.33 160,1813.33 L1440,1813.33 C1469.46,1813.33 1493.33,1789.46 1493.33,1760 L1493.33,960 L1600,960 L1600,1760 C1600,1848.37 1528.37,1920 1440,1920 L160,1920 C71.6345,1920 0,1848.37 0,1760 L0,480 C0,391.634 71.6344,320 160,320 L960,320 L960,426.667 L160,426.667 Z M533.333,705.803 L1223.66,1120 L533.333,1534.2 L533.333,705.803 Z M640,894.197 L640,1345.8 L1016.34,1120 L640,894.197 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAddMediaLine = /*#__PURE__*/function (_Component) {
  _inherits(IconAddMediaLine, _Component);

  var _super = _createSuper(IconAddMediaLine);

  function IconAddMediaLine() {
    _classCallCheck(this, IconAddMediaLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconAddMediaLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAddMedia",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAddMediaLine.displayName = "IconAddMediaLine";
  return IconAddMediaLine;
}(Component);

IconAddMediaLine.glyphName = 'add-media';
IconAddMediaLine.variant = 'Line';
IconAddMediaLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAddMediaLine;
export { IconAddMediaLine };